import { axiosPrivate } from '@/shared/api/axios'
import { API } from '@/shared/constants/api'
import type { IStateLookup } from '../hooks/use-states-query'

/** Lookups para selectors externos; el CRUD admin vive en states-admin.service.ts. */
export const statesService = {
  getLookup: () => axiosPrivate.get<IStateLookup[]>(API.states.lookup).then((r) => r.data)

  // `getMyTransitions` se fue el 2026-08-05 con su hook y con el handler v1 detrás. Los estados
  // que el usuario puede leer salen de `GET /api/v2/me/state-transitions`.
}
